import React from "react";
import { Globe, Coins, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import { useLocale } from "@/context/LocaleContext";

const LOCALES = [
  { value: "fr", label: "Français", short: "FR" },
  { value: "en", label: "English", short: "EN" },
  { value: "de", label: "Deutsch", short: "DE" },
];

const CURRENCIES = [
  { value: "eur", label: "EUR (€)", short: "€ EUR" },
  { value: "gbp", label: "GBP (£)", short: "£ GBP" },
];

export function LanguageCurrencySwitcher({ variant = "header" }) {
  const { locale, setLocale, currency, setCurrency, t } = useLocale();
  const isCompact = variant === "header";

  return (
    <div className={isCompact ? "flex items-center gap-1" : "flex items-center gap-2"}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            aria-label={t("nav.language")}
            data-testid="language-switcher-trigger"
            className={`inline-flex items-center gap-1 rounded-full border border-levami-sable text-levami-charbon hover:bg-levami-ivoire transition-colors ${
              isCompact ? "h-8 px-2.5 text-xs" : "h-9 px-3 text-sm"
            }`}
          >
            <Globe className="h-3.5 w-3.5" />
            {locale.toUpperCase()}
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="bg-levami-creme border-levami-sable min-w-[150px]">
          {LOCALES.map((l) => (
            <DropdownMenuItem
              key={l.value}
              onClick={() => setLocale(l.value)}
              data-testid={`language-option-${l.value}`}
              className="flex items-center justify-between cursor-pointer text-levami-charbon focus:bg-levami-ivoire"
            >
              {l.label}
              {locale === l.value && <Check className="h-3.5 w-3.5 text-levami-primary" />}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            aria-label={t("nav.currency")}
            data-testid="currency-switcher-trigger"
            className={`inline-flex items-center gap-1 rounded-full border border-levami-sable text-levami-charbon hover:bg-levami-ivoire transition-colors ${
              isCompact ? "h-8 px-2.5 text-xs" : "h-9 px-3 text-sm"
            }`}
          >
            <Coins className="h-3.5 w-3.5" />
            {currency.toUpperCase()}
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="bg-levami-creme border-levami-sable min-w-[150px]">
          {CURRENCIES.map((c) => (
            <DropdownMenuItem
              key={c.value}
              onClick={() => setCurrency(c.value)}
              data-testid={`currency-option-${c.value}`}
              className="flex items-center justify-between cursor-pointer text-levami-charbon focus:bg-levami-ivoire"
            >
              {c.label}
              {currency === c.value && <Check className="h-3.5 w-3.5 text-levami-primary" />}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
